import React, { Component } from 'react';
import { Link, NavLink } from "react-router-dom";
import PageWrapper from '../PageWrapper/PageWrapper';

import './About.scss';

const About = (props) => {
    window.scrollTo(0, 0)
    return (
        <div class="About">
            <PageWrapper>
                <section>
                    <header>
                        <h1>Snappin&apos; necks and cashing checks</h1>
                        <h2>Always Be GIF&apos;in&trade;</h2>
                        <Link to="/" class="button">Browse GIFs now</Link>
                    </header>
                    <div class="PageWrapper--grid">
                        <div>
                            <img src="/assets/img/gifs/jesse/whats-the-deal.gif" alt="decor" />
                            <h2>Deep research into today&apos;s sales teams led to one massive epiphany.</h2>
                            <h2><i>There aren&apos;t any GIFs that close deals.</i></h2>
                            <h3>So Klue just saved the industry. Again.</h3>
                            <p>Our global world sales enablement taskforce took the challenge to heart. Over one thousand iterations later, and finally here it is. GIF&apos;in.</p>
                            <h3>The world&apos;s first GIFfective Intelligence Platform.</h3>
                            <p>To sales people everywhere, Klue heard you. And you are very welcome.</p>
                            <p>You can always be better &mdash; Always Be GIF&apos;in.</p>
                            <p><a href="/klue/" class="button">Made by Klue</a></p>
                        </div>
                        <div>
                            <img src="/assets/img/gifs/jesse/lets-do-lunch.gif" alt="decor" />
                            <h2>Come on, you still writing plain wordy emails to prospects and leads?</h2>
                            <h2><i>The drive-thru kid at Arby&apos;s is outselling you.</i></h2>
                            <h3>😇Get GIF&apos;in and spice up those emails</h3>
                            <p>Nobody reads those cold emails you send. But why not at least have a laugh when creating them?</p>
                            
                            <h3>💥Animated awkwardness wins</h3>
                            <p><b>"Hey Mrs. Sales VP, are you looking to work with the best in 2020?"</b></p>
                            <p>OMG, call the coroner cuz this deal is DEAD. But wait... toss a classic GIF in the mix and the next email is as simple as "sign here".</p>
                            <h3>💯Close deals with a tight meme</h3>
                            <p>No one reads anything you write anymore.</p>
                            <p>But a message in cheesy pixelated movie-images? Well, I hope you have a doctor on speed dial, cuz your commissions are about to get sick.</p>
                            
                        </div>
                    </div>
                </section>
                <footer>
                    <Link to="/"><img src="/assets/img/abg.logo.001.png" /></Link>
                    <p>&copy; 2020 In hindsight. All rights reserved &mdash; Klue Labs Inc.</p>
                </footer>
            </PageWrapper>
        </div>
    )
}
export default About;